var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.isScaledUpParent ? "scaled-up-container" : "",
        { "blurred-bg": _vm.component.bind.hasBlurBackground }
      ],
      attrs: { id: "modal" },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.clickOutside($event)
        }
      }
    },
    [
      _vm.isMounted
        ? _c(
            "div",
            {
              ref: "innerModal",
              staticClass: "modal-container",
              style: Object.assign({}, _vm.modalStyle, {
                backgroundColor: _vm.getBackgroundColor
              })
            },
            [
              _vm.showExitIcon
                ? _c(
                    "div",
                    {
                      ref: "closeIcon",
                      staticClass: "close-icon-wrapper",
                      attrs: {
                        tabindex: "0",
                        id: "close-icon",
                        "aria-label": _vm.$t(
                          "app.classes.modal.closeIcon.ariaLabel.text"
                        ),
                        lang: _vm.narratorLang
                      },
                      on: {
                        keypress: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.closeModal($event)
                        },
                        click: _vm.closeModal
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "close-icon",
                          attrs: { "aria-hidden": "true" }
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 14 14"
                              }
                            },
                            [
                              _c("path", {
                                staticClass: "cls-1",
                                attrs: {
                                  id: "Path_8625",
                                  "data-name": "Path 8625",
                                  d:
                                    "M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,\n            19,12,13.41,17.59,19,19,17.59,13.41,12Z",
                                  transform: "translate(-5 -5)",
                                  fill: "var(--midGrey2)"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                _vm.component.bind.is,
                _vm._g(
                  _vm._b(
                    {
                      tag: "component",
                      staticClass: "modal-component",
                      class: { scaledUp: _vm.isScaledUp },
                      attrs: { salesPopupType: _vm.component.salesPopupType },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "modal-header",
                            fn: function(ref) {
                              var titleText = ref.titleText
                              var titleStyle = ref.titleStyle
                              var hasSeparator = ref.hasSeparator
                              return [
                                _c("modal-header", {
                                  attrs: {
                                    titleText: titleText,
                                    titleStyle: titleStyle,
                                    hasSeparator: hasSeparator
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2366874851
                      )
                    },
                    "component",
                    _vm.component.bind,
                    false
                  ),
                  _vm.component.on
                )
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shared/elements/modal/Modal.vue?vue&type=template&id=b19422c6&scoped=true&
// module id = null
// module chunks = 